export default __webpack_public_path__ + "static/AppMoneyWalkie14-7ebd34aa7260dcb7cc7c3c8698c27408.png";